<template>
  <HeadingLv1 :text="'よくある質問'" />
  <div class="faq u-containar">
    <!-- {{ lists }} -->
    <p>
      「サービスの使い方」「研修先探しについての疑問」「イベント申込方法」など、お客様から寄せられたご質問についてお答えしています。
    </p>
    <section class="list">
      <HeadingLv3 :text="'注目のよくある質問'" />
      <Loader v-if="state.loading" />
      <div v-else>
        <div v-if="lists.length">
          <FaqLists v-for="list in lists" :key="list.id" :list="list" />
        </div>
        <Alert
          v-else
          text="ただいま注目の質問は存在しません。"
          style="margin-top:20px"
        />
      </div>
    </section>
    <FaqCategories />
  </div>
  <FaqContact />
</template>

<script lang="ts">
import { reactive, ref, watch, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import FaqLists from '@/components/block/FaqLists.vue'
import Alert from '@/components/elements/Alert.vue'
import FaqCategories from '@/components/block/FaqCategories.vue'
import FaqContact from '@/components/block/FaqContact.vue'
import Loader from '@/components/elements/Loader.vue'
import { axiosSetting } from '@/utils/axiosSetting'

export default defineComponent({
  name: 'Faq',
  components: {
    HeadingLv1,
    HeadingLv3,
    FaqLists,
    Alert,
    FaqCategories,
    FaqContact,
    Loader
  },
  setup() {
    const state = reactive({
      loading: true
    })
    const lists = ref([])
    const route = useRoute()
    const ajax = axiosSetting('cms', 'block')

    const getLists = () => {
      ajax
        .get(
          `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/faq?faq_pickup_flag=1&per_page=5`
        )
        .then((res) => {
          // console.log(res.data)
          lists.value = res.data
        })
        .finally(() => {
          state.loading = false
        })
    }

    getLists()

    watch(
      () => route.path,
      () => {
        getLists()
      }
    )

    return {
      state,
      lists
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.faq {
  margin-bottom: 38px;
  @include mixins.media() {
    margin-bottom: 92px;
  }
}
p {
  margin-bottom: 49px;
}
.list {
  margin-bottom: 54px;
}
</style>
